<script>
import options from './StafetDeltagPaaHoldStepThree.options'
export default options
</script>

<template>
  <article
    class="kb-stafet-step kb-stafet-join-a-team-step-three kb-optimizely-forms"
  >
    <h2 class="kb-stafet-step__title">
      {{ labels.registerDeltagereTitle }}
    </h2>

    <div class="kb-stafet-step__input-wrapper">
      <FormCheckbox
        :modelValue="addMoreParticipants.toString()"
        v-model="addMoreParticipants"
        :label="labels.registerDeltagereBoolLabel"
        fieldName="addMoreParticipants"
        :onChangeCallback="(e) => toggleAddMoreParticipants(e.target.checked)"
      />

      <div v-if="addMoreParticipants">
        <StafetAddDeltager
          :labels="labels"
          :onChangeCallback="updateAddParticipants"
          :data="participants"
          :displayInputError="displayInputError"
          :excludeMail="true"
        />
      </div>
    </div>

    <StafetActions
      :nextStepCallback="() => nextStepCallback(stepModel)"
      :nextStepLabel="labels.formNavigationNextStep3"
      :previousStepCallback="previousStepCallback"
      :previousStepLabel="labels.formNavigationPrevStep"
    />
  </article>
</template>
